// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.v--modal .body[data-v-e65a9b74] {
  justify-content: center;
}
.v--modal .header[data-v-e65a9b74] {
  padding-bottom: 20px !important;
}
.modal-body .custom-input-hot-keys[data-v-e65a9b74] {
  display: flex;
  justify-content: center;
  flex-direction: row;
  width: 100%;
  max-width: 388px;
  padding: 0 10px;
  font-size: 20px;
  border-width: 1px !important;
  background-color: var(--bg-color);
}
.modal-body .custom-input-hot-keys .hotkeysplaceholder[data-v-e65a9b74] {
  position: absolute;
  z-index: 9999;
  display: flex;
  justify-content: center;
  font-weight: normal;
  border: none;
  color: transparent;
  text-shadow: 0px 0px 0px #313131;
  font-size: 18px;
  white-space: pre;
  height: 72px;
}
.modal-body .custom-input-hot-keys input[data-v-e65a9b74] {
  position: relative;
  z-index: 100;
  display: flex;
  justify-content: center;
  font-weight: 500;
  line-height: 4;
  width: 350px;
  border: none;
  color: transparent;
  text-shadow: 0px 0px 0px #7b7b7b;
  text-align: center;
  background-color: var(--bg-color);
}
.modal-body .custom-input-hot-keys input[data-v-e65a9b74]:focus {
  outline-width: 0;
}
.modal-body .custom-input-hot-keys .clear-sign[data-v-e65a9b74] {
  width: 18px;
  display: flex;
  color: transparent;
  text-shadow: 0px 0px 0px #adadad;
  cursor: pointer;
}
.modal-body .custom-input-hot-keys .clear-sign .fa-times[data-v-e65a9b74] {
  font-weight: 200;
  color: #d2cdcd;
  font-size: 28px;
  align-self: center;
}
`, "",{"version":3,"sources":["webpack://./js/app/components/custom/CustomInputHotKeys.vue"],"names":[],"mappings":"AAAA;EACE,uBAAuB;AACzB;AACA;EACE,+BAA+B;AACjC;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,4BAA4B;EAC5B,iCAAiC;AACnC;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,gBAAgB;EAChB,cAAc;EACd,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,gCAAgC;EAChC,kBAAkB;EAClB,iCAAiC;AACnC;AACA;EACE,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,gCAAgC;EAChC,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB","sourcesContent":[".v--modal .body[data-v-e65a9b74] {\n  justify-content: center;\n}\n.v--modal .header[data-v-e65a9b74] {\n  padding-bottom: 20px !important;\n}\n.modal-body .custom-input-hot-keys[data-v-e65a9b74] {\n  display: flex;\n  justify-content: center;\n  flex-direction: row;\n  width: 100%;\n  max-width: 388px;\n  padding: 0 10px;\n  font-size: 20px;\n  border-width: 1px !important;\n  background-color: var(--bg-color);\n}\n.modal-body .custom-input-hot-keys .hotkeysplaceholder[data-v-e65a9b74] {\n  position: absolute;\n  z-index: 9999;\n  display: flex;\n  justify-content: center;\n  font-weight: normal;\n  border: none;\n  color: transparent;\n  text-shadow: 0px 0px 0px #313131;\n  font-size: 18px;\n  white-space: pre;\n  height: 72px;\n}\n.modal-body .custom-input-hot-keys input[data-v-e65a9b74] {\n  position: relative;\n  z-index: 100;\n  display: flex;\n  justify-content: center;\n  font-weight: 500;\n  line-height: 4;\n  width: 350px;\n  border: none;\n  color: transparent;\n  text-shadow: 0px 0px 0px #7b7b7b;\n  text-align: center;\n  background-color: var(--bg-color);\n}\n.modal-body .custom-input-hot-keys input[data-v-e65a9b74]:focus {\n  outline-width: 0;\n}\n.modal-body .custom-input-hot-keys .clear-sign[data-v-e65a9b74] {\n  width: 18px;\n  display: flex;\n  color: transparent;\n  text-shadow: 0px 0px 0px #adadad;\n  cursor: pointer;\n}\n.modal-body .custom-input-hot-keys .clear-sign .fa-times[data-v-e65a9b74] {\n  font-weight: 200;\n  color: #d2cdcd;\n  font-size: 28px;\n  align-self: center;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
